<div class="layout-container">
  <header></header>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
  <footer></footer>
</div>
